<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Danh sách lưu trú
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="4">
                    <el-form-item label="Tên dịch vụ" prop="">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value['luu_tru.ten']
                        "
                        clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)"
                      >
                      </el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.ngon_ngu"
                    :placeholder="'Ngôn ngữ'"
                    @change="fn_tableSearch()"
                    :default-first-option="true"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listNgonNgu"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.visible"
                    :placeholder="'Trạng thái hiển thị'"
                    @change="fn_tableSearch()"
                    :default-first-option="true"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.trangThai"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <el-button
                @click="fn_handle('create-admin')"
                v-if="mData.currentUser.roles.includes('Officer')"
                type="info"
                plain
                >{{ aLang.c_create_new_post }}</el-button
              >
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="luu_tru.ten"
            label="Tên dịch vụ"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false"
                >{{ scope.row.luu_tru ? scope.row.luu_tru.ten : "" }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column
            v-if="
              mData.currentUser.roles.includes('Officer') ||
              mData.currentUser.roles.includes('Admin')
            "
            prop="dich_vu.du_lieu_khai_bao.user_ten"
            label="Tên đơn vị"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                placement="top-start"
                :content="
                  scope.row.dich_vu && scope.row.dich_vu.du_lieu_khai_bao
                    ? scope.row.dich_vu.du_lieu_khai_bao.user_ten
                    : scope.row.diem_den_an_toan
                    ? scope.row.diem_den_an_toan.thong_tin_chung &&
                      scope.row.diem_den_an_toan.thong_tin_chung.ten
                      ? scope.row.diem_den_an_toan.thong_tin_chung.ten
                      : scope.row.diem_den_an_toan.ten || ''
                    : ''
                "
              >
                <span>{{
                  scope.row.dich_vu && scope.row.dich_vu.du_lieu_khai_bao
                    ? scope.row.dich_vu.du_lieu_khai_bao.user_ten
                    : scope.row.diem_den_an_toan
                    ? scope.row.diem_den_an_toan.thong_tin_chung &&
                      scope.row.diem_den_an_toan.thong_tin_chung.ten
                      ? scope.row.diem_den_an_toan.thong_tin_chung.ten
                      : scope.row.diem_den_an_toan.ten || ""
                    : ""
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="visible"
            label="Trạng thái hiển thị"
            width="160px"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.visible == true ? "Hiển thị" : "Đang ẩn" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ngon_ngu"
            label="Ngôn ngữ"
            :sortable="mData.tableRules.allowSorting"
            width="130px"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{ fn_getLanguageName(scope.row.ngon_ngu) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('unApproved', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_unApproved"
                v-if="
                  mData.currentUser.roles.includes('Officer') ||
                  mData.currentUser.roles.includes('Admin')
                "
              >
                <i class="fas fa-ban"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <ModalSelectDonViLuuTru
      @submit="gotoCreateDonViCungCap"
      :configModal="mData.showFormAdd"
    />
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "@/service/DataService";
import DichVuApi from "@/moduleApi/DichVuApi";
import DDATApi from "@/moduleApi/DDATApi";
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
import MethodService from "../../../service/MethodService";
import LuuTruModel from "@/views/admin/LuuTru/LuuTruModel";
import ModalSelectDonViLuuTru from "@/views/admin/LuuTru/ModalSelectDonViLuuTru";
import mushroom from "@/service/api/trangvang-api";
import { Filter } from 'mushroomjs';
export default {
  components: {
    ModalSelectDonViLuuTru,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "LuuTru", //requied
        tableRules: MethodService.copyObject(LuuTruModel.tableRules),
        dataDefault: {
          trangThai: [
            {
              code: "",
              text: "Tất cả",
            },
            {
              code: "true",
              text: "Hiển thị",
            },
            {
              code: "false",
              text: "Ẩn",
            },
          ],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
        },
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        ifHavePermission: false,
        ifHaveCreate: false,
        showFormAdd: {
          show: false,
        },
      },
    };
  },
  created() {
    this.fn_hashUrl();
    this.getLuuTruList();
  },
  mounted() {
    this.mData.tableRules.dataSearch.value.visible = "";
  },
  methods: {
    gotoCreateDonViCungCap(DonVi) {
      this.mData.showFormAdd.show = false;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-create-admin",
        params: { id: DonVi.donViCungCapId },
      });
    },
    async getLuuTruList() {
      let loaiFilter = Filter.and(
        Filter.or(Filter.eq("loai", "hotel"), Filter.eq("loai", "tourist_area")),
        Filter.isNull("luu_tru.ten", false)
      ).build();

      let dataFilter = {
        filters:
          (this.mData.tableRules.filters
            ? this.mData.tableRules.filters + "&"
            : "") + loaiFilter,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }

      mushroom.tv_dich_vu.invalidCache();
      let res = await mushroom.tv_dich_vu.listAsync(dataFilter);
      let resData = res.result || [];
      let diemDenAnToanIds = (res.result || []).map(
        (id) => id.diem_den_an_toan_id
      );
      let arrDiemDenAnToanIds =
        MethodService.findListItemDifferent(diemDenAnToanIds);

      if (arrDiemDenAnToanIds && arrDiemDenAnToanIds.length > 0) {
        let resDiemDenAnToan = await DDATApi.list({
          filters: "id:in:" + arrDiemDenAnToanIds.join(","),
        });
        if (resDiemDenAnToan && resDiemDenAnToan.result) {
          resData.map((item) => {
            item.diem_den_an_toan = resDiemDenAnToan.result.find(
              (x) => x.id == item.diem_den_an_toan_id
            );
            if (item.diem_den_an_toan && !item.diem_den_an_toan.ten) {
              item.diem_den_an_toan.ten =
                (item.diem_den_an_toan.thong_tin_chung &&
                  item.diem_den_an_toan.thong_tin_chung.ten) ||
                (item.diem_den_an_toan.du_lieu_khai_bao &&
                  item.diem_den_an_toan.du_lieu_khai_bao.user_ten) ||
                "";
            }
          });
        }

        let resDonViCungCapRes = await DonViCungCapApi.list({
          filters: "id:in:" + arrDiemDenAnToanIds.join(","),
        });
        if (resDonViCungCapRes && resDonViCungCapRes.result) {
          resData.map((item) => {
            item.dich_vu = resDonViCungCapRes.result.find(
              (x) => x.id == item.diem_den_an_toan_id
            );
          });
        }
      }

      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getLuuTruList();
      }
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getLuuTruList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getLuuTruList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getLuuTruList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      } else if (type == "create-admin") {
        this.mData.showFormAdd.show = true;
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "unApproved") {
        this.$confirm(LanguageService.lang.c_unApproveConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_unApproved(row.id);
          })
          .catch(() => {});
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    async fn_delete(id) {
      await DichVuApi.delete(id);
      this.getLuuTruList();
    },
    async fn_unApproved(id) {
      await DichVuApi.unApprovedDichVu(id);
      this.getLuuTruList();
    },
    fn_getLanguageName(code) {
      let lang = (this.mData.dataDefault.listNgonNgu || []).find(
        (item) => item.id == code
      );
      return lang ? lang.name : code || "";
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  },
};
</script>

<style scope>
.text-css {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-css p {
  margin: 0;
}
</style>
